module.exports = __webpack_public_path__ + "static/media/chat-inactive.c65c38ad.svg";